import React from 'react';
import { Reveal } from '../ui/Reveal';
import { SARASWATI_IMG } from '../../data/retiro';
export function Saraswati() {
  return <section className="w-full px-5 py-24 sm:px-8 sm:py-32" style={{
    backgroundColor: 'rgba(176,146,191,0.08)'
  }} data-id="element-163">
      <div className="mx-auto grid max-w-7xl items-center gap-12 md:grid-cols-2 md:gap-16" data-id="element-164">
        <Reveal data-id="element-165">
          <div className="relative overflow-hidden rounded-[2rem]" data-id="element-166">
            <img src={SARASWATI_IMG} alt="Ilustración de la diosa Saraswati con el cisne blanco Hamsa y flores de loto" className="aspect-[4/3] w-full object-cover" data-id="element-167" />
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-168">
          <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.28em]" style={{
          color: 'var(--glossygrape)'
        }} data-id="element-169">
            <span className="h-px w-8" style={{
            background: 'var(--glossygrape)'
          }} data-id="element-170" />
            Diosa del Conocimiento
          </span>
          <h2 className="mt-5 font-heading text-3xl font-light leading-tight sm:text-4xl" style={{
          color: 'var(--ink)'
        }} data-id="element-171">
            Saraswati: La Diosa de la Pureza y la Sabiduría
          </h2>
          <p className="mt-5 text-base leading-relaxed" style={{
          color: 'rgba(42,36,32,0.72)'
        }} data-id="element-172">
            Invocamos a Saraswati para abrir tu mente y tu alma a la sabiduría
            interior que siempre has poseído. A través de ceremonias con
            ofrendas Canang Sari, te conectarás con la energía creativa y
            sanadora que fluye en todo lo que existe en Bali.
          </p>
          <blockquote className="mt-8 border-l-2 pl-5 font-heading text-lg font-light italic leading-relaxed" style={{
          borderColor: 'var(--glossygrape)',
          color: 'var(--ink)'
        }} data-id="element-173">
            🌸 Aquí, la limpieza espiritual no es un ritual — es un despertar.
          </blockquote>
        </Reveal>
      </div>
    </section>;
}